export default {
  none: {
    fullName: '',
    metaOnly: true,
  },
  fr_be_at: {
    fullName: '',
    metaOnly: true,
    picture: require('../resources/fr_be_at.png'),
  },
  ge_mx_id: {
    fullName: '',
    metaOnly: true,
    picture: require('../resources/ge_mx_id.png'),
  },
  by_ua: {
    fullName: '',
    metaOnly: true,
    picture: require('../resources/by_ua.png'),
  },
}



// WEBPACK FOOTER //
// ./src/content/biznisnet2020/data/presenters.js